/** Importato per primo da main.tsx: deve girare prima dei moduli che creano formattatori numerici all'avvio. */
import { Capacitor } from "@capacitor/core";
import { installItalianGrouping } from "./numberFormat";

try {
  if (Capacitor.isNativePlatform() || localStorage.getItem("ml_native_ux") === "1") installItalianGrouping();
} catch {
  /* storage non disponibile */
}
